import styled from "styled-components";
import { FlexipageColors, headingSizes } from "../../Flexipage/Global/FlexipageStyles";

export const CaseStudyGridWrapper = styled.section`
	h2 {
		margin-bottom: 5rem;
		text-align: center;

		text-wrap: balance;
		color: #144056;
		font-size: ${headingSizes.h4.desktop[0]};
		line-height: ${headingSizes.h4.desktop[1]};
		font-family: ${headingSizes.h4.fontFamily};
		font-weight: ${headingSizes.h4.fontWeight};

		@media (max-width: ${FlexipageColors.breakpointTablet}) {
			font-size: ${headingSizes.h4.tablet[0]};
			line-height: ${headingSizes.h4.tablet[1]};
		}

		@media (max-width: ${FlexipageColors.breakpointMobile}) {
			font-size: ${headingSizes.h4.mobile[0]};
			line-height: ${headingSizes.h4.mobile[1]};
		}
	}

	.case-studies {
		display: flex;
		flex-direction: column;
		gap: 5rem;
	}
`